// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Project details (/user/projects/:id). Scoped under .project-details-page. */

.project-details-page {
  min-width: 0;
}

.project-details-page .project-details__name {
  overflow-wrap: anywhere;
  white-space: normal;
}

.project-details-page .project-details__team {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
}

.project-details-page .project-details__section {
  margin-top: var(--ds-space-4);
}

.project-details-page .projectTabs > .ant-tabs-nav {
  margin-bottom: var(--ds-space-3);
}

.project-details-page .ant-descriptions-item-content {
  overflow-wrap: anywhere;
}
`, "",{"version":3,"sources":["webpack://./src/commons/Projects/ProjectDetailsView/ProjectDetailsView.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/* Project details (/user/projects/:id). Scoped under .project-details-page. */\n\n.project-details-page {\n  min-width: 0;\n}\n\n.project-details-page .project-details__name {\n  overflow-wrap: anywhere;\n  white-space: normal;\n}\n\n.project-details-page .project-details__team {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n}\n\n.project-details-page .project-details__section {\n  margin-top: var(--ds-space-4);\n}\n\n.project-details-page .projectTabs > .ant-tabs-nav {\n  margin-bottom: var(--ds-space-3);\n}\n\n.project-details-page .ant-descriptions-item-content {\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
